import CardSection from "../CardSection"
import DetailsCard from "../DetailsCard"
import InputField from "../InputField"

interface Props {
    filterValue: string
    onFilterChange: (value: string) => void
}

const UserFilter = ({filterValue, onFilterChange}: Props) => {
 
    return (
        <CardSection>
            <DetailsCard>
            <InputField
                id="userSearchField"
                placeholder="Search to find users..."
                value={filterValue || ''}
                onEnterKeyOrBlur={value => onFilterChange(value)}
            />
            </DetailsCard>
        </CardSection>
    )
}

export default UserFilter